module.exports = __webpack_public_path__ + "6b36dc18884ff04c13e25795f326274e.jpg";


//////////////////
// WEBPACK FOOTER
// ../components/brothers-portrait.jpg
// module id = 1074
// module chunks = 0